var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.443 16.982-4.103-.076c-1.329-.027-2.66.026-3.963-.248C.396 16.248.255 14.24.108 12.555a29.12 29.12 0 0 1 .258-7.128c.216-1.318 1.064-2.104 2.377-2.19 4.43-.31 8.888-.274 13.308-.129a9.49 9.49 0 0 1 1.397.169c2.272.403 2.328 2.679 2.475 4.595a26.363 26.363 0 0 1-.196 5.803c-.225 1.592-.656 2.927-2.475 3.056-2.278.168-4.504.304-6.79.26 0-.01-.012-.01-.019-.01Zm-2.412-4.03c1.717-.998 3.401-1.979 5.108-2.97-1.72-.998-3.401-1.979-5.108-2.97v5.94Z",
    fill: "#fff"
  })));
};
export default SvgYoutube;